export interface SettingsDotJson {
  demoModeEmailAddress: string
  demoModeEnabled: boolean
  marketsWithFactoryModelsShowAllStartMode: number[]
  oneTrustEnabled: boolean
}

// TODO: Move to a more appropriate source file.
export async function fetchSettings(): Promise<SettingsDotJson> {
  const settingsResponse = await fetch('/settings.json')
  const settingsDynamic = await settingsResponse.json()
  const emailDynamic = settingsDynamic['demoModeEmailAddress']
  const demoModeEmailAddress: string =
    typeof emailDynamic === 'string' ? emailDynamic : ''
  const validEmailFormat =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+.)+[^<>()[\].,;:\s@"]{2,})$/i
  const demoModeEnabled: boolean = validEmailFormat.test(demoModeEmailAddress)
  let oneTrustEnabled = settingsDynamic['oneTrustEnabled']
  if ((oneTrustEnabled as string).startsWith('#{')) {
    console.log('One trust is not enabled.')
    oneTrustEnabled = false
  }
  if (typeof oneTrustEnabled === 'string') {
    const oneTrustEnabledString = oneTrustEnabled
    oneTrustEnabled = oneTrustEnabledString === 'true'
  }
  const maybeMarketIdArray =
    settingsDynamic['marketsWithFactoryModelsShowAllStartMode']
  if (!Array.isArray(maybeMarketIdArray)) {
    throw new Error(
      'Expected marketsWithFactoryModelsShowAllStartMode to be an array',
    )
  }
  const marketsWithFactoryModelsShowAllStartMode = []
  for (const marketId of maybeMarketIdArray) {
    if (typeof marketId !== 'number') {
      throw new Error(
        'Expected marketsWithFactoryModelsShowAllStartMode to only contain numbers, found: ' +
          marketId,
      )
    }
    marketsWithFactoryModelsShowAllStartMode.push(marketId)
  }
  return {
    demoModeEmailAddress,
    demoModeEnabled,
    marketsWithFactoryModelsShowAllStartMode,
    oneTrustEnabled,
  }
}
